const NUM_SONGS = 15;

export default function SkeletonListSongABC() {
  const songCount = [...Array(NUM_SONGS)].map(Math.random);

  return (
    <div className="p-2 pt-6">
      {songCount.map((i) => {
        return (
          <div key={i} className="mb-6">
            <div className={"h-[22px] mb-2 w-[60%] skeleton"}></div>
            <div className={"h-4 w-[90%] skeleton"}></div>
          </div>
        );
      })}
    </div>
  );
}
